import Vue from 'vue';

/**
 *  The COS tool.
 */
import App from './App.vue';

/**
 *  The router and store.
 */
import router from './router';
import store from './store';

/**
 *  Load Vuetify's datepicker for the preferred date of installation.
 */
import Vuetify, { VDatePicker } from 'vuetify/lib';

Vue.use(Vuetify, {
    components: {
        VDatePicker,
    },
});

/**
 *  Install the components so they can be used throughout the tool.
 */
import Components from '@/components';

Vue.use(Components);

/**
 *  Install the filters.
 */
import InstallFilters from './filters';

InstallFilters(Vue);

/**
 *  Create the Vue instance and mount it into the index main.
 */
new Vue({
    router,
    store,
    vuetify: new Vuetify(),
    render: (h) => h(App),
}).$mount('#ccos-tool');
